import { Pause, Play, RotateCw, Volume2, VolumeOff } from 'lucide-react';
import { cn } from '@/lib/utils';
import ExpandIcon from '@/components/icons/ExpandIcon';
import { useWebinarT } from '@/hooks/useWebinarT';

interface ControleProps {
  onPlay: () => void;
  onPause: () => void;
  onGoBack: () => void;
  onGoForward: () => void;
  onRefresh: () => void;
  onToggleMute: () => void;
  onFullscreen?: () => void;
  // onDownload?: () => void;
  isPlaying: boolean;
  isMuted: boolean;
  showGoBack?: boolean;
  showGoForward?: boolean;
  showMute?: boolean;
}

export default function Controle({
  onPlay,
  onPause,
  onGoBack,
  onGoForward,
  onRefresh,
  onToggleMute,
  onFullscreen,
  // onDownload,
  isPlaying,
  isMuted,
  showGoBack = true,
  showGoForward = true,
  showMute = true,
}: ControleProps) {
  const { t } = useWebinarT('common');

  return (
    <div className=" flex items-center justify-center lg:gap-2  lg:py-2 lg:px-4 px-2 bg-white rounded-full shadow-lg">
      {showGoBack && (
        <button type="button" onClick={onGoBack} className="cursor-pointer p-2">
          <img src="/assets/video-back.svg" alt="back" className="size-6" />
        </button>
      )}

      <button
        type="button"
        onClick={onPlay}
        className={cn('cursor-pointer p-2', isPlaying && 'bg-accent rounded-lg')}
      >
        <Play className="size-4" />
      </button>

      {showGoForward && (
        <button type="button" onClick={onGoForward} className="cursor-pointer p-2">
          <img src="/assets/video-forward.svg" alt="forward" className="size-6" />
        </button>
      )}

      <button
        type="button"
        onClick={onPause}
        className={cn('cursor-pointer p-2', !isPlaying && 'bg-accent rounded-lg')}
      >
        <Pause className="size-4" />
      </button>

      <button type="button" onClick={onRefresh} className="cursor-pointer p-2">
        <RotateCw className="size-4" />
      </button>

      {onFullscreen && (
        <button
          type="button"
          onClick={onFullscreen}
          className="cursor-pointer p-2"
          aria-label={t('liveSettings.fullscreen')}
        >
          <ExpandIcon size={20} />
        </button>
      )}

      {/* {onDownload && (
        <button
          type="button"
          onClick={onDownload}
          className="cursor-pointer p-2"
          aria-label="Télécharger la vidéo"
        >
          <Download className="size-4" />
        </button>
      )} */}

      {showMute && (
        <button type="button" onClick={onToggleMute} className="cursor-pointer p-2">
          {isMuted ? <VolumeOff className="size-4" /> : <Volume2 className="size-4" />}
        </button>
      )}
    </div>
  );
}
